import { Modal, Stack, Text, Button, Group, Alert } from "@mantine/core";
import {
  IconAlertTriangle,
  IconDeviceFloppy,
  IconTrash,
} from "@tabler/icons-react";

interface NewCaseModalProps {
  opened: boolean;
  onClose: () => void;
  onDiscard: () => void;
  onSaveAndNew: () => void;
  hasUnsavedChanges: boolean;
  isSaving?: boolean;
}

export default function NewCaseModal({
  opened,
  onClose,
  onDiscard,
  onSaveAndNew,
  hasUnsavedChanges,
  isSaving = false,
}: NewCaseModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Text fw={600}>Start New Case</Text>}
      centered
      size="lg"
    >
      <Stack gap="md">
        {hasUnsavedChanges ? (
          <>
            <Alert
              icon={<IconAlertTriangle size={18} />}
              color="orange"
              variant="light"
            >
              You have unsaved changes in the current case. Would you like to
              save them before starting a new case, or discard them?
            </Alert>

            <Group gap="sm" justify="flex-end">
              <Button
                leftSection={<IconTrash size={16} />}
                onClick={onDiscard}
                variant="light"
                color="red"
                disabled={isSaving}
              >
                Discard
              </Button>

              <Button
                leftSection={<IconDeviceFloppy size={16} />}
                onClick={onSaveAndNew}
                loading={isSaving}
              >
                Save
              </Button>
            </Group>
          </>
        ) : (
          <>
            <Text size="sm">
              Are you sure you want to start a new case? The current case will
              remain as a draft.
            </Text>

            <Group justify="flex-end" gap="sm">
              <Button variant="light" onClick={onClose}>
                Cancel
              </Button>
              <Button onClick={onSaveAndNew} loading={isSaving}>
                Start New Case
              </Button>
            </Group>
          </>
        )}
      </Stack>
    </Modal>
  );
}
